export default {
      id: "circle-wait-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.svg#circle-wait",
      toString: function () {
        return this.url;
      }
    }